import NotFound from './NotFound'

export * from './NotFound'

export default NotFound
